import { render, staticRenderFns } from "./ElementsReference.vue?vue&type=template&id=703bce3e"
import script from "./ElementsReference.vue?vue&type=script&lang=js"
export * from "./ElementsReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports